
import {fromEvent as observableFromEvent,  Observable } from "rxjs";

import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgModel } from "@angular/forms";
import { debounceTime, map } from "rxjs/operators";

@Directive({ selector: "[keystrokeDebounce]" })
export class KeystrokeDebounceDirective implements OnInit {
    @Input() delay = 500;
    @Output() ngModelChangeDebounce: EventEmitter<any> = new EventEmitter();

    constructor(private elementRef: ElementRef, private model: NgModel) {
    }

    ngOnInit(): void {
        const eventStream = observableFromEvent(this.elementRef.nativeElement, "keyup").pipe(
            map(() => this.model.value),
            debounceTime(this.delay));

        eventStream.subscribe((input) => {
            this.ngModelChangeDebounce.emit(input);
        });
    }

}
